/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row4_MulticaInputs */

const en_mk_cmp_row4_multica = /** @type {(inputs: Mk_Cmp_Row4_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent chat only, not person-to-person`)
};

const id_mk_cmp_row4_multica = /** @type {(inputs: Mk_Cmp_Row4_MulticaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanya chat ke agen, bukan sesama orang`)
};

/**
* | output |
* | --- |
* | "Agent chat only, not person-to-person" |
*
* @param {Mk_Cmp_Row4_MulticaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row4_multica = /** @type {((inputs?: Mk_Cmp_Row4_MulticaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row4_MulticaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row4_multica(inputs)
	return en_mk_cmp_row4_multica(inputs)
});